export enum FinancialConnectionStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DISCONNECTED = 'disconnected',
    SUSPENDED = 'suspended',
}
